import { render } from "./VsTab.vue?vue&type=template&id=5f99d5c6"
import script from "./VsTab.vue?vue&type=script&lang=js"
export * from "./VsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__